<script>
  import { error } from "@/stores/stores"

  error.set({ errorCode: 404 })
</script>
